import axiosInstance from './axiosConfig';

export const getAdvertisementsApi = (params) => axiosInstance.get('/advertisements', { params });
export const createAdvertisementApi = (payload) => axiosInstance.post('/advertisements', payload);
export const updateAdvertisementApi = (id, payload) =>
  axiosInstance.put(`/advertisements/${id}`, payload);
export const deleteAdvertisementApi = (id) => axiosInstance.delete(`/advertisements/${id}`);
export const uploadAdvertisementImageApi = (id, file) => {
  const formData = new FormData();
  formData.append('image', file);
  return axiosInstance.post(`/advertisements/${id}/image`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getActiveAdvertisementsApi = () => axiosInstance.get('/public/advertisements');
export const registerAdViewApi = (id) => axiosInstance.post(`/public/advertisements/${id}/view`);
export const registerAdClickApi = (id) => axiosInstance.post(`/public/advertisements/${id}/click`);